// import fetch from 'isomorphic-fetch';
// import superagent from 'superagent';
import config from './config';
import merge from 'lodash/merge';
import Cookies from 'js-cookie';
import Url from 'url';

// function formatUrl(path) {
//   let adjustedPath = path[0] !== '/' ? '/' + path : path;
//   if (__SERVER__) {
//     // Prepend host and port of the API server to the path.
//     // return 'http://localhost:' + config.apiPort + adjustedPath;
//     // hack for now since no api server running
//     // return 'http://localhost:' + '3000/api' + adjustedPath;

//     return 'http://local:' + config.apiPort + '/api' + adjustedPath;

//   }
//   // Prepend `/api` to relative URL, to proxy to API server.
//   // return '/api' + adjustedPath;
//   return 'http://local:' + config.apiPort + '/api' + adjustedPath;
// }

class ApiClient {
  constructor(ctx) {
    this.ctx = ctx;
    ['get', 'post', 'put', 'patch', 'delete'].forEach(method => {
      this[method] = (path, opts = {}) => {
        opts.method = method.toUpperCase();
        return this.go(path, opts);
      };
    });
  }

  async go(path, opts = {}) {
    // var env = process.env.NODE_ENV;
    var env = process.env.REACT_APP_ENV;
    var host =
      env === 'local' || env === 'test' || env === 'development'
        ? config.apiHost + ':' + config.apiPort
        : config.apiHost;

    var url = Url.format({
      protocol: config.protocol,
      host: host,
      query: opts.qs,
      //pathname: opts.url || Path.join(this.basePath, opts.path || ''),
      pathname: '/api' + path, // || Path.join(this.basePath, opts.path || ''),
    });
    // console.log(url);
    // var url = path;
    var options = {
      method: opts.method,
      headers: {
        Accept: 'application/json',
        'X-SIGHT-UUID': sessionStorage.getItem('uuid'),
        // 'Authorization': 'Bearer ' + JSON.parse(localStorage.auth).accessToken
      },
    };

    if (!opts.formData) {
      options.headers['Content-Type'] = 'application/json';
    }

    let accessToken;
    if (__SERVER__) {
      accessToken = this.ctx.cookies.get('accessToken');
    } else if (__CLIENT__ && __TEST__) {
      accessToken = '7a50e96bed6862b93a6761b0485e6b0aaaf3e203';
    } else {
      accessToken = Cookies.get('accessToken');
    }

    if (accessToken) {
      options.headers.Authorization = 'Bearer ' + accessToken;
    }

    if (opts.headers) {
      merge(options.headers, opts.headers);
    }

    if (opts.body) {
      if (options.headers['Content-Type'] === 'application/json') {
        options.body = JSON.stringify(opts.body);
      } else {
        options.body = opts.body;
      }
    }

    var response = await fetch(url, options)
      .catch(status => {
        var err = Error(status.statusText);
        err.json = {
          message: 'Server is down',
          code: 500,
        };
        throw err;
      })
      .then(status);
    var res = await response.json();
    return res;
  }
}

async function status(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }
  var err = Error(response.statusText);
  err.json = await response.json();
  throw err;
  //throw new Error(response.statusText)
}

// class ApiClient2 {
//   constructor(req) {
//     ['get', 'post', 'put', 'patch', 'del'].
//       forEach((method) => {
//         this[method] = (path, options) => {
//           return new Promise((resolve, reject) => {
//             let request = superagent[method](formatUrl(path));
//             if (options && options.params) {
//               request.query(options.params);
//             }
//             if (__SERVER__) {
//               // if (req.get('cookie')) {
//               //   req.set('cookie', req.get('cookie'));
//               // }
//             }
//             if (options && options.data) {
//               request.send(options.data);
//             }
//             request.end((err, res) => {
//               if (err) {
//                 reject( res ? res.body : err);
//               } else {
//                 resolve(res.body);
//               }
//             });
//           });
//         };
//       });
//   }
// }
export default ApiClient;



// WEBPACK FOOTER //
// ./src/ApiClient.js